import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Hidden from "@insite/mobius/Hidden";
import Img from "@insite/mobius/Img";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkProps } from "@insite/mobius/Link";
import Tab from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MinusIcon from "@tSurya/Icons/MinusIcon";
import PlusIcon from "@tSurya/Icons/PlusIcon";
import { COLORS, COMMON, TYPOGRAPHY } from "@tSurya/theme/design";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

const enum fields {
    title = "title",
    tabTitle = "tabTitle",
    desc = "desc",
    numberOfTabs = "numberOfTabs",
    faqBoxes = "faqBoxes",
    cssClass = "cssClass",
    newImage = "newImage",
    image = "image",
    label = "label",
    name = "name",
    baneerImage = "baneerImage",
    description = "description",
    descriptionTittle = "descriptionTittle",
    tabdescription = "tabdescription",
    internalListLinks = "internalListLinks",
    internalListTitle = "internalListTitle",
    internalListDescription = "internalListDescription",
    youtubeSource = "youtubeSource",
    videoSource = "videoSource",
    videoFormat = "videoFormat",
    videoTitle = "videoTitle",
    baneerImageMobile = "baneerImageMobile",
}

interface NameArray {
    name: string;
    videoTitle: string;
    tabdescription: string;
    baneerImage: string;
    baneerImageMobile: string;
    youtubeSource: string;
    videoSource: string;
    videoFormat: string;
    faqBoxes: FAQModel[];
}

interface TabModel {
    fields: NameArray;
}
interface InternalListModel {
    fields: InternalListArray;
}

interface InternalListArray {
    internalListTitle: string;
    internalListDescription: string;
}

interface FAQArray {
    questions: string;
    answers: string;
    newImage: string;
    image: string;
    title: string;
    label: string;
    link: LinkFieldValue;
    description: string;
    descriptionTittle: string;
    internalListLinks: InternalListModel[];
}

interface FAQModel {
    fields: FAQArray;
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.tabTitle]: string;
        [fields.desc]: string;
        [fields.numberOfTabs]: TabModel[];
        [fields.faqBoxes]: FAQModel[];
        [fields.internalListLinks]: InternalListModel;
        [fields.cssClass]: string;
        [fields.tabdescription]: string;
        [fields.name]: string;
        [fields.baneerImage]: string;
        [fields.baneerImageMobile]: string;
    };
}

type Props = OwnProps;
export interface SurTabularDataStyles {
    tabView?: InjectableCss;
    tabTitle?: InjectableCss;
    container?: InjectableCss;
    tabdesc?: InjectableCss;
    imageStyles?: InjectableCss;
    tabGroup?: TabGroupPresentationProps;
    accordianContainer?: InjectableCss;
    accordianSection?: AccordionSectionPresentationProps;
    internalList?: InjectableCss;
    internalListTitle?: InjectableCss;
    internalListDescription?: InjectableCss;
    internalListContainer?: InjectableCss;
    ctaLink?: LinkProps;
    button?: InjectableCss;
    descContainer?: InjectableCss;
    tabName?: InjectableCss;
    adminVideo?: InjectableCss;
    videoContainer?: InjectableCss;
    videoTittle?: InjectableCss;
    videoWrapper?: InjectableCss;
    leftContainer?: InjectableCss;
    rightContainer?: InjectableCss;
    listImage?: InjectableCss;
    descriptionContanier?: InjectableCss;
    descriptionTittle?: InjectableCss;
    description?: InjectableCss;
    imageStylesMobile?: InjectableCss;
    tabContainer?: InjectableCss;
    imageContainer?: InjectableCss;
    emptyBorder?: InjectableCss;
    tabdescSpan?: InjectableCss;
}
export const tabularDataStyles: SurTabularDataStyles = {
    tabView: {
        css: css`
            background: ${getColor("common.background")};
            padding: 8px 12px;
            font-style: normal;
            min-width: auto;
            outline: 0;
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.msmall};
            transition: none !important;
            color: ${getColor("text.main")};
            cursor: pointer;
            :focus {
                outline: 0;
            }
            /* border: 1px solid red; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 12px;
                    `,
                    css`
                        padding: 12px;
                    `,
                    css`
                        padding: 12px;
                    `,
                    null,
                    null,
                ])}
            &[aria-selected="false"] {
                border-bottom: 2px solid transparent;
             
            }
            &[aria-selected="true"] {
                span {
                    color: ${getColor("text.main")};
                    font-weight: 700;
                }

                border-bottom: 2px solid ${getColor("text.main")};
            
            }
        `,
    },
    tabTitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 600;
            font-size: 26px;
            line-height: 34px;
            text-align: center;
            color: ${getColor("text.main")};
            margin-bottom: 30px;
            text-transform: uppercase;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.xlargest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                        margin-bottom: 15px;
                    `,
                    css`
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.xlargest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                        margin-bottom: 15px;
                    `,
                    css`
                        font-weight: ${TYPOGRAPHY.weight.mediumbold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.xlargest};
                        line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
                        margin-bottom: 15px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    tabdesc: {
        css: css`
            max-width: 955px;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            margin-bottom: 35px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 15px;
                        padding: 0px 20px;
                    `,
                    css`
                        margin-bottom: 15px;
                        padding: 0px 20px;
                    `,
                    css`
                        margin-bottom: 15px;
                        padding: 0px 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    tabdescSpan: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 400;
            font-size: 15px;
            line-height: 24px;
            text-align: center;
            color: ${getColor("text.main")};
        `,
    },
    imageStyles: {
        css: css`
            max-width: ${COMMON.width.content}px;
            max-height: 540px;
            img {
                object-fit: contain;
                width: 100%;
                max-width: ${COMMON.width.content}px;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 0px 20px;
                    `,
                    css`
                        padding: 0px 20px;
                    `,
                    css`
                        padding: 0px 20px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    container: {
        css: css`
            max-width: ${COMMON.width.content}px;
            margin: 0 auto;
        `,
    },
    tabGroup: {
        cssOverrides: {
            tabGroup: css`
                align-items: center;
                justify-content: flex-start;
                gap: 12px;
                padding: 0px;
                z-index: 9;
                margin: 30px auto 35px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin: 15px auto 17px;
                        `,
                        css`
                            margin: 15px auto 17px;
                        `,
                        css`
                            margin: 15px auto 17px;
                        `,
                        null,
                        null,
                    ])}
                > li > span {
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-style: normal;
                    font-weight: 400;
                    font-size: 15px;
                    line-height: 24px;
                    color: ${getColor("text.main")};
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                font-family: ${TYPOGRAPHY.fontFamily.title};
                                font-weight: ${TYPOGRAPHY.weight.base};
                                color: ${getColor("text.main")};
                                font-size: ${TYPOGRAPHY.size.base};
                                line-height: ${TYPOGRAPHY.lineHeight.msmall};
                            `,
                            css`
                                font-family: ${TYPOGRAPHY.fontFamily.title};
                                font-weight: ${TYPOGRAPHY.weight.base};
                                color: ${getColor("text.main")};
                                font-size: ${TYPOGRAPHY.size.base};
                                line-height: ${TYPOGRAPHY.lineHeight.msmall};
                            `,
                            css`
                                font-family: ${TYPOGRAPHY.fontFamily.title};
                                font-weight: ${TYPOGRAPHY.weight.base};
                                color: ${getColor("text.main")};
                                font-size: ${TYPOGRAPHY.size.base};
                                line-height: ${TYPOGRAPHY.lineHeight.msmall};
                            `,
                            null,
                            null,
                        ])}
                }
            `,
            tabContent: css`
                border: none;
                padding: 0px !important;
                max-width: ${COMMON.width.content}px;
                margin: 0 auto;
                /* margin-bottom: 62px; */
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-bottom: 0px;
                        `,
                        css`
                            margin-bottom: 0px;
                        `,
                        css`
                            margin-bottom: 0px;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    accordianContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            overflow: hidden;
        `,
    },
    accordianSection: {
        headerProps: {
            css: css`
                & button,
                & button:focus {
                    background-color: ${getColor("common.backgroundContrast")};

                    padding: 24px 20px;
                    border: 0;
                    > span:first-of-type {
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-weight: ${TYPOGRAPHY.weight.bold};
                        color: ${getColor("text.main")};
                        font-size: ${TYPOGRAPHY.size.smaller};
                        line-height: ${TYPOGRAPHY.lineHeight.base};
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                padding: 9px 20px 25px 40px;
                border: 0;
                &:not(dd[hidden]) {
                    display: flex;
                    display: flex;
                    align-items: center;
                }
                > span {
                    padding-left: 40px;
                    > p {
                        display: list-item;
                        margin-bottom: 0;
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                        font-weight: ${TYPOGRAPHY.weight.base};
                        color: ${getColor("text.accent")};
                        font-size: ${TYPOGRAPHY.size.smaller};
                        line-height: ${TYPOGRAPHY.lineHeight.base};
                    }
                }
            `,
        },
        expandIconProps: {
            src: PlusIcon,
        },
        collapseIconProps: {
            src: MinusIcon,
        },
    },

    internalListTitle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            color: ${getColor("text.main")};
        `,
    },
    internalListDescription: {
        css: css`
            max-width: 393px;
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            color: ${getColor("text.accent")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        text-align: center;
                    `,
                    css`
                        max-width: 100%;
                        text-align: center;
                    `,
                    css`
                        max-width: 100%;
                        text-align: center;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    button: {
        css: css`
            outline: 0;
            background-color: ${getColor("primary")};
            border: 1px solid ${getColor("primary")};
            padding: 10px 34px;
            width: max-content;
            max-width: 100%;
            /* display: block; */
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px 22px;
                    `,
                    css`
                        padding: 10px 22px;
                    `,
                    css`
                        padding: 10px 22px;
                    `,
                    null,
                    null,
                ])}
            span {
                display: block;
                font-family: ${TYPOGRAPHY.fontFamily.base};
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 24px;
                text-align: center;
                color: white !important;
                font-style: normal !important;
            }
        `,
    },
    descContainer: {
        css: css`
            max-width: 955px;
            margin: 0 auto;
        `,
    },
    tabName: {
        css: css`
            padding: 15px 0px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            background: ${getColor("primary")};
            span {
                font-family: ${TYPOGRAPHY.fontFamily.base};
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 28px;
                /* identical to box height, or 140% */

                text-align: center;

                /* White */

                color: #ffffff;
            }
        `,
    },
    adminVideo: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-height: 200px;
                        video {
                            max-height: 200px;
                            width: 100%;
                        }
                    `,
                    css`
                        max-height: 200px;
                        video {
                            max-height: 200px;
                            width: 100%;
                        }
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    videoContainer: {
        css: css`
            margin-top: 35px !important;
            max-width: 955px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-width: 100%;
                        margin: 0px;
                        margin-top: 20px !important;
                    `,
                    css`
                        max-width: 100%;
                        margin: 0px;
                        margin-top: 20px !important;
                    `,
                    css`
                        max-width: 100%;
                        margin: 0px;
                        margin-top: 20px !important;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    videoTittle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            color: ${getColor("text.main")};
            margin-bottom: 18px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 16px;
                        line-height: 26px;
                        margin-bottom: 9px;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 26px;
                        margin-bottom: 9px;
                    `,
                    css`
                        font-size: 16px;
                        line-height: 26px;
                        margin-bottom: 9px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    videoWrapper: {
        css: css`
            max-width: 955px;
            max-height: 537px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-height: 200px;
                        video {
                            height: 100%;
                            display: flex;
                        }

                        iframe {
                            display: flex;
                            height: 100%;
                            width: 100%;
                            max-height: 200px;
                        }
                    `,
                    css`
                        max-height: 200px;
                        video {
                            height: 100%;
                            display: flex;
                        }
                        iframe {
                            display: flex;
                            height: 100%;
                            width: 100%;
                            max-height: 200px;
                        }
                    `,
                    css`
                        video {
                            height: 100%;
                            display: flex;
                        }
                        iframe {
                            display: flex;
                            width: 100%;
                        }
                    `,
                    null,
                    null,
                ])}
        `,
    },
    internalListContainer: {
        css: css`
            margin-top: 65px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 30px;
                    `,
                    css`
                        margin-top: 30px;
                    `,
                    css`
                        display: flex;
                        justify-content: center;
                        flex-direction: column;
                        align-items: center;
                        margin-top: 30px;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    internalList: {
        css: css`
            max-width: 1060px;
            max-height: 388px;
            margin: 0 auto;
            display: flex;
            column-gap: 60px;
            margin-bottom: 125px;
            &:last-child {
                margin-bottom: 0px;
            }
            &:nth-child(odd) {
                flex-direction: row;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-bottom: 0px;
                            max-height: 100%;
                            flex-direction: column;
                        `,
                        css`
                            margin-bottom: 0px;
                            max-height: 100%;
                            flex-direction: column;
                        `,
                        css`
                            margin-bottom: 0px;
                            max-height: 100%;
                            flex-direction: column;
                            align-items: center;
                        `,
                        null,
                        null,
                    ])}
            }
            &:nth-child(even) {
                flex-direction: row-reverse;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            margin-bottom: 0px;
                            max-height: 100%;
                            flex-direction: column;
                        `,
                        css`
                            margin-bottom: 0px;
                            max-height: 100%;
                            flex-direction: column;
                        `,
                        css`
                            margin-bottom: 0px;
                            max-height: 100%;
                            flex-direction: column;
                            align-items: center;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    leftContainer: {
        css: css`
            max-width: 520px;
            height: 100%;
            /* max-height: 388px; */
            width: 100%;
        `,
    },
    rightContainer: {
        css: css`
            max-width: 400px;
            width: 100%;
            display: flex;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        max-width: 100%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    listImage: {
        css: css`
            display: flex;
            max-width: 520px;
            width: 100%;
            height: 100%;
            max-height: 388px;
            img {
                object-fit: contain;
                width: 100%;
                max-width: 520px;
            }
        `,
    },
    descriptionContanier: {
        css: css`
            display: flex;
            justify-content: center;
            padding: 24px 22px 20px;
            /* border: 1px solid black; */
            display: flex;
            flex-direction: column;
            row-gap: 10px;
        `,
    },

    descriptionTittle: {
        css: css`
            p {
                &:first-child {
                    margin-bottom: 0px;
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-style: normal;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 24px;
                    color: ${getColor("text.accent")};
                }
                &:nth-child(2) {
                    margin-bottom: 0px;
                    font-family: ${TYPOGRAPHY.fontFamily.base};
                    font-style: normal;
                    font-weight: 700;
                    font-size: 18px;
                    line-height: 26px;
                    color: ${getColor("text.main")};
                }
            }
        `,
    },
    description: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-style: normal;
            font-weight: 400;
            font-size: 15px;
            line-height: 24px;
            color: ${getColor("text.main")};
        `,
    },
    imageStylesMobile: {
        css: css`
            width: 100%;
            height: auto;
            aspect-ratio: 1/1;
            object-fit: cover;
            background-size: contain;
            display: flex;
        `,
    },
    tabContainer: {
        css: css`
            > div[class^="TabGroupWrapper"] {
                padding: 0px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px 20px !important;
                        `,
                        css`
                            padding: 0px 20px !important;
                        `,
                        css`
                            padding: 0px 20px !important;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    imageContainer: {
        css: css`
            display: flex;
        `,
    },
    emptyBorder: {
        css: css`
            max-width: 1080px;
            margin: 0 auto;
            border-top: 1px solid #d5cebe;
        `,
    },
};

const styles = tabularDataStyles;

const SurRugGuideSizing: React.FC<Props> = ({ fields, id }) => {
    // const { url } = useGetLink(fields.link);
    const [expandedAccordian, setExpandedAccordian] = React.useState<number | null>(null);

    const AllContent = [...fields.numberOfTabs];

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.descContainer}>
                <Typography as="h2" {...styles.tabTitle}>
                    {fields.name}
                </Typography>
                <StyledWrapper {...styles.tabdesc}>
                    <Typography {...styles.tabdescSpan}>{fields.tabdescription}</Typography>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.emptyBorder}></StyledWrapper>
            <StyledWrapper {...styles.tabContainer}>
                <TabGroup current={AllContent[0]?.fields.name} {...styles.tabGroup}>
                    {AllContent.map(numberOfTab => {
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <Tab
                                headline={numberOfTab.fields.name}
                                tabKey={numberOfTab.fields.name}
                                {...styles.tabView}
                                onClickCapture={() => setExpandedAccordian(null)}
                            >
                                <StyledWrapper {...tabularDataStyles.accordianContainer}>
                                    <StyledWrapper {...styles.tabName}>
                                        <Typography> {numberOfTab.fields.name}</Typography>
                                    </StyledWrapper>
                                    <Hidden below="lg" {...styles.imageContainer}>
                                        <Img
                                            src={numberOfTab.fields.baneerImage}
                                            altText={numberOfTab.fields.name || "Rug Guide Sizing Image"}
                                            {...styles.imageStyles}
                                        />
                                    </Hidden>
                                    <Hidden above="md">
                                        <Img
                                            src={numberOfTab.fields.baneerImageMobile}
                                            altText={numberOfTab.fields.name || "Rug Guide Sizing Image"}
                                            {...styles.imageStylesMobile}
                                        />
                                    </Hidden>
                                    <StyledWrapper {...styles.videoContainer}>
                                        <StyledWrapper {...styles.videoTittle}>
                                            {numberOfTab.fields.videoTitle}
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.videoWrapper}>
                                            {numberOfTab.fields.youtubeSource &&
                                                numberOfTab.fields.videoFormat === "youtube" && (
                                                    <StyledWrapper>
                                                        <iframe
                                                            width="955"
                                                            height="537"
                                                            src={`https://www.youtube.com/embed/${numberOfTab.fields.youtubeSource}`}
                                                            title="YouTube video player"
                                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        ></iframe>
                                                    </StyledWrapper>
                                                )}
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.videoWrapper}>
                                            {numberOfTab.fields.videoSource &&
                                                numberOfTab.fields.videoFormat === "video" && (
                                                    <StyledWrapper {...styles.adminVideo}>
                                                        <video width="955" height="537" controls preload="metadata">
                                                            <track kind="captions" />
                                                            <source
                                                                src={`${numberOfTab.fields.videoSource}#t=0.001`}
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </StyledWrapper>
                                                )}
                                        </StyledWrapper>
                                    </StyledWrapper>
                                    {numberOfTab.fields.faqBoxes && (
                                        <StyledWrapper {...styles.internalListContainer}>
                                            {numberOfTab.fields.faqBoxes.map((item: FAQModel, index: number) => {
                                                return (
                                                    // eslint-disable-next-line react/no-array-index-key
                                                    <StyledWrapper key={index} {...styles.internalList}>
                                                        <StyledWrapper {...styles.leftContainer}>
                                                            <LazyImage
                                                                src={item.fields.image}
                                                                {...styles.listImage}
                                                                altText="Main Image"
                                                            />
                                                        </StyledWrapper>

                                                        <StyledWrapper {...styles.rightContainer}>
                                                            <StyledWrapper {...styles.descriptionContanier}>
                                                                {item.fields.descriptionTittle && (
                                                                    <StyledWrapper {...styles.descriptionTittle}>
                                                                        {parse(
                                                                            item.fields?.descriptionTittle,
                                                                            parserOptions,
                                                                        )}
                                                                    </StyledWrapper>
                                                                )}

                                                                <StyledWrapper {...styles.description}>
                                                                    {item.fields.description}
                                                                </StyledWrapper>
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                );
                                            })}
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            </Tab>
                        );
                    })}
                </TabGroup>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SurRugGuideSizing,
    definition: {
        group: "Common",
        displayName: "SurRugGuideSizing",
        fieldDefinitions: [
            {
                name: fields.name,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 0,
            },
            {
                name: fields.tabdescription,
                displayName: "Descriptioon",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.numberOfTabs,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.name;
                },
                defaultValue: [],
                fieldType: "General",
                sortOrder: 1,
                fieldDefinitions: [
                    {
                        name: "name",
                        displayName: "Tab Name",
                        editorTemplate: "TextField",
                        sortOrder: 0,
                        defaultValue: "",
                    },
                    {
                        displayName: "Banner Image",
                        name: "baneerImage",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        displayName: "Banner Image Mobile",
                        name: "baneerImageMobile",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },

                    {
                        name: "videoTitle",
                        displayName: "Video Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },

                    {
                        name: "videoFormat",
                        editorTemplate: "DropDownField",
                        options: [
                            { displayName: "youtube", value: "youtube" },
                            { displayName: "video", value: "video" },
                        ],
                        defaultValue: "youtube",
                    },
                    {
                        name: "youtubeSource",
                        editorTemplate: "MultilineTextField",
                        displayName: "Youtube URL",
                        defaultValue: "",
                        isVisible: item => item.fields[fields.videoFormat] === "youtube",
                    },
                    {
                        name: "videoSource",
                        editorTemplate: "ImagePickerField",
                        displayName: "Video URL",
                        defaultValue: "",
                        isVisible: item => item.fields[fields.videoFormat] === "video",
                    },
                    {
                        name: fields.faqBoxes,
                        editorTemplate: "ListField",
                        displayName: "Data Fields",
                        getDisplay: (List: HasFields) => {
                            return List.fields.faqBoxes;
                        },
                        defaultValue: [],
                        fieldDefinitions: [
                            {
                                displayName: "image",
                                name: "image",
                                editorTemplate: "ImagePickerField",
                                defaultValue: "",
                            },
                            {
                                name: "descriptionTittle",
                                displayName: "Description Tittle",
                                editorTemplate: "RichTextField",
                                defaultValue: "",
                            },
                            {
                                name: "description",
                                displayName: "Description",
                                editorTemplate: "MultilineTextField",
                                defaultValue: "",
                            },
                        ],
                    },
                ],
            },
            {
                name: fields.cssClass,
                displayName: "Add CSS Class",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
    },
};
export default widgetModule;
